const IS_PRODUCTION_BUILD = process.env.NODE_ENV === 'production';

export const PRODUCTION_FRONTEND_ORIGIN = 'https://app.raisethebaruk.com';
export const PRODUCTION_BACKEND_ORIGIN = 'https://rtb-backend-reep.onrender.com';
export const PRODUCTION_API_BASE_URL = `${PRODUCTION_BACKEND_ORIGIN}/api`;

const trimTrailingSlashes = (value) => String(value || '').trim().replace(/\/+$/, '');

const normalizeOrigin = (value) => {
  const trimmed = trimTrailingSlashes(value);
  return trimmed || null;
};

const normalizeApiBaseUrl = (value) => {
  const trimmed = trimTrailingSlashes(value);
  if (!trimmed) return null;
  return trimmed.endsWith('/api') ? trimmed : `${trimmed}/api`;
};

const getBrowserOrigin = () => {
  if (typeof window === 'undefined') return null;
  return normalizeOrigin(window.location?.origin || '');
};

export const isExplicitLocalDevelopment = () => {
  return !IS_PRODUCTION_BUILD;
};

export const getFrontendOrigin = () => {
  const envOrigin = normalizeOrigin(process.env.REACT_APP_FRONTEND_URL);
  if (envOrigin) return envOrigin;

  const browserOrigin = getBrowserOrigin();
  if (browserOrigin && !IS_PRODUCTION_BUILD) return browserOrigin;

  return PRODUCTION_FRONTEND_ORIGIN;
};

export const getApiBaseUrl = () => {
  const envApiBaseUrl = normalizeApiBaseUrl(process.env.REACT_APP_API_URL);
  if (envApiBaseUrl) return envApiBaseUrl;

  return PRODUCTION_API_BASE_URL;
};

export const getSupabaseUrl = () => {
  const envUrl = normalizeOrigin(process.env.REACT_APP_SUPABASE_URL);
  return envUrl || null;
};

export const getRequiredRuntimeConfig = () => {
  const frontendOrigin = getFrontendOrigin();
  const apiBaseUrl = getApiBaseUrl();
  const supabaseUrl = getSupabaseUrl();
  const supabaseAnonKey = String(process.env.REACT_APP_SUPABASE_ANON_KEY || '').trim() || null;

  return {
    frontendOrigin,
    apiBaseUrl,
    supabaseUrl,
    supabaseAnonKey,
    isExplicitLocalDevelopment: isExplicitLocalDevelopment(),
  };
};